import styled from 'styled-components';

export const TimeframeCustomRadioGroup = styled.div`
  display: flex;
  gap: 24px;
  padding-top: 24px;
`;
